<app-tier-first-controls-view
  [content]="content()"
  [showsAppBackground]="showsAppBackground"
  [allTiersSignal]="allTiersSignal"
  [freeMatchesSignal]="freeMatchesSignal"
  [currentTournamentDataSignal]="currentTournamentDataSignal"
  [soloTiersSignal]="soloTiersSignal"
  [waitingOpponentsStandard]="waitingOpponentsStandard"
  [paymentInFlight]="paymentInFlight()"
  [userBalance]="operatorService.balance()"
  [formattedBalance]="operatorService.formattedBalance()?.text"
  [canShowLocal]="tierListHost.canShowLocal"
  [isMarbles]="tierListHost.isMarbles"
  [unfinishedTimeRemaining]="unfinishedTimeRemaining()"
  [continueButtonLabel]="continueButtonLabel()"
  (wagerClickedEvent)="onWagerClick($event)"
  (tournamentPlayClickedEvent)="onTournamentPlayClick($event)"
  (tutorialRequestedEvent)="tierListHost.onTutorialRequested($event)"
  (leaderboardRequestedEvent)="tierListHost.onLeaderboardRequested($event)"
  (freeMatchClickedEvent)="onFreeMatchClick($event)"
  (soloClickedEvent)="onSoloClick()"
  (practiceClickedEvent)="onPracticeClick()"
  (localClickedEvent)="onLocalClick()"
  (celebrationClearedEvent)="tierListHost.onCelebrationCleared()"
  (continueGameClickedEvent)="onContinueGameClicked()"
/>
